import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { DynamicItem } from 'src/app/main/dynamic/dynamic-item';
import { DynamicEvent } from 'src/app/main/dynamic/dynamic.event';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';
import { OptionModel } from 'src/app/main/dynamic/model/option.model';
import { CompanyModel } from 'src/app/model/company.model';
import { CompanyService } from 'src/app/service/company.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css'],
  animations: [
    trigger('fadeAnimation', [
      state('in', style({opacity: 1})),
      transition(':enter', [
        style({opacity: 0}),
        animate(400)
      ]),
      transition(':leave',
        animate(200, style({opacity: 0})))
    ])
  ]
})
export class CompanyComponent extends DynamicItem implements OnInit {

  documentAttr: AttributeModel
  companyFields: AttributeModel[] = []
  documentMask: string
  companyModel: CompanyModel
  showFieldsOnError: boolean = false
  hasLookupError: boolean = false

  constructor(private companyService: CompanyService) {
    super()
  }

  get documentIsValid(): boolean {
    if(!this.documentAttr){
       return true;
    }
    let isRequired = this.documentAttr.options
    .find(opt => opt.key.toLowerCase() == "required" &&
                 opt.value.toLowerCase() == "true") != null;

    if(!isRequired){
      return true;
    }
    if(!this.documentAttr.value) {
      return false
    }

    return true
  }

  isRequiredDocument(): boolean {
    if(!this.documentAttr) {
      return false;
    }

    let isRequired = this.documentAttr.options
      .find(opt => opt.key.toLowerCase() == "required" &&
                   opt.value.toLowerCase() == "true") != null

    if(!isRequired) {
      isRequired = this.attribute.options
        .some(opt => opt.key.toLowerCase() == "required" &&
                     opt.value.toLowerCase() == "true")
    }

    return isRequired

  }

  isErrorTopDocument(): boolean {
    if(!this.documentAttr) {
      return false
    }

    let isErrorTop = this.documentAttr.options
    .find(opt => opt.key.toLowerCase() == "error-top") != null

    return isErrorTop
  }

  getErrorOnTopCompany(): string{
    if(!this.documentAttr) {
      return ""
    }

    if(!this.isRequiredDocument() || this.documentAttr.value) {
       return null
    }
    let errorMsg = this.documentAttr.options
      .find(opt => opt.key.toLowerCase() == "error-top")
    return errorMsg?.value
  }

  get hasFieldsFilled(): boolean {
    return this.companyFields.some(attr => attr.value)
  }

  ngOnInit() {
    let isRequiredOpt = this.attribute.options
        .find(opt => opt.key.toLowerCase() == "required" &&
                     opt.value.toLowerCase() == "true")

    if(isRequiredOpt) {
      this.addToEnvOptions(isRequiredOpt)
    }

    this.documentAttr = this.attribute.attributes
      .find(attr => attr.options.some(opt => opt.key.toLowerCase() == "companyfield" &&
                                             opt.value.toLowerCase() == "document"))

    if(this.documentAttr) {
      this.companyFields = this.attribute.attributes
        .filter(attr => attr.key != this.documentAttr.key)

      this.documentMask = this.getDocumentMask()
    }

    if(this.attribute && this.attribute.options) {
      let showOnErrorOpt = this.attribute.options
        .find(opt => opt.key.toLowerCase() == "showfieldsonerror")

      if(showOnErrorOpt) {
        this.showFieldsOnError = showOnErrorOpt.value.toLowerCase() == "true"
      }
    }
  }

  getDocumentTitle(): string {
    if(!this.documentAttr) {
      return ""
    }

    let titleOpt = this.documentAttr.options
      .find(opt => opt.key.toLowerCase() == "title")

    if(titleOpt) {
      return titleOpt.value
    }

    return this.documentAttr.key
  }

  getDocumentMask(): string {
    if (!this.documentAttr || !this.documentAttr.options) {
      return "";
    }

    let opt = this.documentAttr.options
        .find(option => option.key.toLowerCase() == "mask");

    if (opt) {
      return opt.value;
    }
    else {
      return "";
    }
  }

  onDynamicEmit(events: DynamicEvent[]) {
    this.emitEvents(events)
  }

  onValueChange(event: any) {
    const value = event.target.value;

    if(this.documentMask && this.documentMask.length == value.length) {
      this.hasLookupError = false
      this.getCompanyData()
    }
  }

  private getCompanyData() {
    let errorMessage = this.getErrorMessagDocument()

    if(this.documentAttr != null && this.documentAttr.value) {
      this.hasLookupError = false
      Swal.showLoading()

      this.companyService
        .getBy(this.documentAttr.value)
        .subscribe((companyModel: CompanyModel) => {
          Swal.close()
          if(companyModel.document) {
            if(companyModel.status == "ATIVA") {
              this.companyModel = companyModel
              this.loadCompanyData()
              this.hasLookupError = false
            } else {
              this.companyModel = null
              Swal.fire("Atenção", `A empresa ${companyModel.companyName} está ${companyModel.status}`, "error")
              this.hasLookupError = false
            }
          } else {
            this.companyModel = null
            Swal.fire("Atenção", errorMessage, "error")
            this.hasLookupError = true
          }
          this.emit({name: "autosave"})
        }, () => {
          this.companyModel = null
          Swal.fire("Atenção", errorMessage, "error")
          this.hasLookupError = true
        })
    }
  }

  private getErrorMessagDocument(): string  {
    let errorMessage = ""

    if(!this.documentAttr) {
      return errorMessage
    }

    let errorOpt = this.documentAttr.options
      .find(opt => opt.key.toLowerCase() == "errornotfound")

    if(errorOpt) {
      errorMessage = errorOpt.value
    } else {
      errorMessage = "O CNPJ não foi encontrado"
    }

    return errorMessage
  }

  private loadCompanyData() {
    this.companyFields.forEach(attr => {
      let fieldNameOpt = attr.options
        .find(opt => opt.key.toLowerCase() == "companyfield")

      if(fieldNameOpt) {
        this.fillData(attr, fieldNameOpt)
      }
    })
  }

  private fillData(attribute: AttributeModel, option: OptionModel) {
    if(option.value.toLowerCase() != "address") {
      attribute.value = this.companyModel[option.value]
    } else if(this.companyModel.address) {
      attribute.value = `${this.companyModel[option.value]}, ${this.companyModel["number"]} - ${this.companyModel["neighborhood"]} - ${this.companyModel["city"]} - ${this.companyModel["state"]} - ${this.companyModel["zipCode"]}`
      attribute.attributes.forEach(attr => {
        let integrationField = attr.options
          .find(opt => opt.key.toLowerCase() == "integrationfield")?.value

        if(!integrationField) {
          integrationField = attr.key.toLowerCase()
        }

        attr.value = this.companyModel[integrationField]
      })
    }
  }
}
